module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gmap-map', {
    staticClass: "m-t-20",
    staticStyle: {
      "width": "400px",
      "height": "500px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 14,
      "map-type-id": "terrain"
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": true
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69aabf2c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Gmap.vue
// module id = 515
// module chunks = 1